import {
  applySnapshot,
  clone,
  flow,
  IAnyModelType,
  types,
} from "mobx-state-tree";
import moment from "moment";
import { ErrorModel } from "../../components/common/error";
import { FileModel, IFileModel } from "../../components/fileupload/FileModel";
import i18n from "../../i18n";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";
import { SelectListModel } from "../share";
import { ISelectListModel } from "../share/SelectListModel";
import systemHelperAPI from "../systemhelper/SystemHelperService";
import sdgsAPI from "../../modules/sdgs/SDGsService";
import orgAPI, { GroupCodeType } from "./OrgService";

export const ChangeRequestContact = types
  .model("ChangeRequestContact", {
    contactName: customtypes.optional(types.string, ""),
    contactTel: customtypes.optional(types.string, ""),
  })
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
  }));
export type IChangeRequestContact = typeof ChangeRequestContact.Type;

const LOVModel = types
  .model("LOVModel", {
    lovKey: customtypes.optional(types.number, 0),
    lovCode: customtypes.optional(types.string, ""),
    lovValue: customtypes.optional(types.string, ""),
    lovGroupCode: customtypes.optional(types.string, ""),
    isCanceled: customtypes.optional(types.boolean, false),
    orderNo: customtypes.optional(types.string, ""),
    parentGroup: customtypes.optional(types.string, ""),
    parentLOV: customtypes.optional(types.string, ""),
    remark: customtypes.optional(types.string, ""),
  })
  .views((self: any) => ({
    get lawTypeOption() {
      return {
        id: self.lovKey,
        title: self.lovValue,
        check: false,
        disabled: false,
        message: "",
      };
    },
    get lovDropdownOption() {
      return {
        id: self.lovKey,
        text: self.lovValue,
        value: self.lovCode,
      };
    },
    get lovFilterType() {
      return {
        label: self.lovValue,
        value: self.lovCode,
      };
    },
  }))
  .actions((self: any) => ({
    //
  }));

export type ILOVModel = typeof LOVModel.Type;

export const LOVGroupModel = types
  .model("LOVModel", {
    list: types.optional(types.array(LOVModel), []),
    groupCode: types.optional(types.string, ""),
    error: types.optional(ErrorModel, {}),
  })
  .views((self: any) => ({
    get lovDropdownOptions() {
      const options: any = [];
      self.list.forEach((item: ILOVModel, index: number) => {
        options.push(item.lovDropdownOption);
      });
      return options;
    },
  }))
  .actions((self: any) => ({
    getLOVItemLabel(value: any) {
      const selected = self.list;
      console.log("selected value: ", selected);
      console.log("getLOVItemLabel value: ", value);
      const selectedItem = selected
        ? selected.find((item: ILOVModel) => item.lovValue === value)
        : undefined;
      return selectedItem ? selectedItem.lovValue : "-";
    },
    setGroupCode: (groupCode: GroupCodeType) => {
      self.groupCode = groupCode;
    },
    setParentGroup: (parentGroup: string | null) => {
      self.parentGroupCode = parentGroup;
    },
    setParentLOV: (parentLOV: string | null) => {
      self.parentLOV = parentLOV;

    },
    getLOVByGroup: flow(function* () {
      try {
        const result = yield systemHelperAPI.getLOVByGroup({
          lovgroupcode: self.groupCode,
        });
        self.list = result.data;
        self.error.tigger = false;
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        //
      }
    }),
    GetLOVByParent: flow(function* () {
      try {
        const result = yield systemHelperAPI.getLOVByParent({
          parentGroupCode: self.parentGroupCode,
          parentLOVCode : self.parentLOV,
        });
        self.list = result.data;
        self.error.tigger = false;
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        //
      }
    }),
    getLOVByGroupByIframe: flow(function* () {
      try {
        const result = yield sdgsAPI.GetLOVByGroupByIframe({
          lovgroupcode: self.groupCode,
        });
        self.list = result.data;
        self.error.tigger = false;
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        //
      }
    }),
  }));

export type ILOVGroupModel = typeof LOVGroupModel.Type;

export const ShareHolderModel = types
  .model("ShareHolderModel", {
    shareHolderID: types.maybeNull(types.number),
    shareHolderName: customtypes.optional(types.string, ""),
    publicDebtActs: customtypes.optional(types.array(SelectListModel), []),
    financeDebtActs: customtypes.optional(types.array(SelectListModel), []),
    proportion: customtypes.optional(types.number, 0),
  })
  .views((self: any) => ({
    //
  }))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    setShareHolder: (id: number | null, description: string) => {
      self.shareHolderID = id;
      self.shareHolderName = description;
    },
    setProportion: (value: string) => {
      self.proportion = +value;
    },
  }));

export type IShareHolderModel = typeof ShareHolderModel.Type;

export const ActionModel = types
  .model("ActionModel", {
    id: customtypes.optional(types.number, 0),
    userID: customtypes.optional(types.string, ""),
    userName: customtypes.optional(types.string, ""),
    actionTime: customtypes.optional(types.string, moment().format()),
    action: customtypes.optional(types.string, ""),
    actionType: customtypes.optional(types.string, ""),
    actionCode: customtypes.optional(types.string, ""),
  })
  .views((self: any) => ({
    get fullname() {
      /// ยังไม่มีค่ามาจากพี่เก่ง
      return self.userName;
    },
  }));
export type IActionModel = typeof ActionModel.Type;

export const OrganizeModel = types
  .model("OrganizeModel", {
    organizeID: customtypes.optional(types.number, 0),
    organizationCode: customtypes.optional(types.string, ""),
    organizationTHName: customtypes.optional(types.string, ""),
    orgAffiliate: types.optional(SelectListModel, {}),
    orgType: types.optional(SelectListModel, {}),
    field: customtypes.optional(SelectListModel, {}),
    subField: customtypes.optional(SelectListModel, {}),
    establishmentLaw: customtypes.optional(types.string, "-"),
    shareHolders: customtypes.optional(types.array(ShareHolderModel), []),
    pdaProportion: customtypes.optional(types.number, 0),
    fdaProportion: customtypes.optional(types.number, 0),
    lawOfDebts: customtypes.optional(types.array(FileModel), []),
    attachFiles: customtypes.optional(types.array(FileModel), []),
    remark: customtypes.optional(types.string, "-"),
    publicDebtActs: customtypes.optional(types.array(SelectListModel), []),
    publicDebtSection: customtypes.optional(types.string, "-"),
    financeDebtActs: customtypes.optional(types.array(SelectListModel), []),
    financeDebtSection: customtypes.optional(types.string, "-"),
    hasLoanPower: types.optional(types.boolean, false),
    loanPowerSection: customtypes.optional(types.string, "-"),
    debtCalculation: customtypes.optional(SelectListModel, {}),
    requestStatus: types.maybeNull(ActionModel),
    lastApproved: types.maybeNull(ActionModel),
    pdmoLawReguration: customtypes.optional(types.string, ""),
    changeRequest: types.maybe(types.late((): IAnyModelType => OrganizeModel)),
    pdmoType: types.maybeNull(SelectListModel),
    template: types.maybeNull(SelectListModel),
    requestorContact: customtypes.optional(ChangeRequestContact, {}),
    error: types.optional(ErrorModel, {}),
    loading: types.optional(types.boolean, false),
  })
  .views((self: any) => ({
    get publicDebtsSelectedIdList() {
      const selectedIdList: number[] = [];
      self.publicDebtActs.forEach((item: ISelectListModel, index: number) => {
        selectedIdList.push(item.id);
      });
      return selectedIdList;
    },
    get financeDebtsSelectedIdList() {
      const selectedIdList: number[] = [];
      self.financeDebtActs.forEach((item: ISelectListModel, index: number) => {
        selectedIdList.push(item.id);
      });
      return selectedIdList;
    },
    get requestStatusLabel() {
      return self.requestStatus ? self.requestStatus.actionType : "-";
    },
    get requestStatusUserName() {
      return self.requestStatus ? self.requestStatus.userName : "-";
    },
    get requestStatusAction() {
      return self.requestStatus ? self.requestStatus.action : "-";
    },
    get shareHoldersPropSummary() {
      const summary = self.shareHolders.reduce(
        (sum: number, shareHolder: IShareHolderModel) =>
          (sum * 100 + shareHolder.proportion * 100) / 100,
        0
      );
      return summary;
    },
    get lawOfDebtsIds() {
      const ids: number[] = [];
      self.lawOfDebts.forEach((file: IFileModel) => {
        if (file.id) {
          ids.push(file.id);
        }
      });
      return ids;
    },
    get attachFilesIds() {
      const ids: number[] = [];
      self.attachFiles.forEach((file: IFileModel) => {
        if (file.id) {
          ids.push(file.id);
        }
      });
      return ids;
    },
    get templateCode() {
      return self.template ? self.template.code : "";
    },
  }))
  .actions((self: any) => ({
    getOrganization: flow(function* () {
      try {
        console.log('Getting organization with ID:', self.organizeID);
        self.loading = true;
        const result = yield orgAPI.getById(self.organizeID);
        console.log('API result:', result);
        self.setAllField(result.data);
        if (self.requestStatus) {
          yield self.getOrganizeChangeRequest();
        } else {
          // Set changeRequest กรณีไว้ new requestStatus
          const { changeRequest, ..._self } = self.toJSON(); // ลบ changeRequest ออก
          _self.changeRequest = undefined;
          self.changeRequest = _self;
        }
        return result.data;
      } catch (e) {
        console.error('Error in getOrganization:', e);
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    getPDMOLawReguration: flow(function* () {
      try {
        self.loading = true;
        const result = yield orgAPI.getPDMOLawReguration(self.organizeID);
        self.pdmoLawReguration = result.data;
        self.error.tigger = false;
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    updateOrganization: flow(function* () {
      try {
        self.loading = true;
        self.onValidateForm();
        if (self.orgType.code !== "SEN" && self.orgType.code !=="FIN" && self.orgType.code !=="FUND" && self.orgType.code !=="LIM" && self.orgType.code !=="OTH") {
          // หน่วยงานรัฐวิสาหกิจ
          self.field.resetAll();
          self.subField.resetAll();
          self.shareHolders = [];
        }
        const result = yield orgAPI.update(self, self.organizeID);
        return result;
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    getOrganizeChangeRequest: flow(function* () {
      try {
        self.changeRequest.loading = true;
        const result = yield orgAPI.getOrganizeChangeRequest(self.organizeID);
        if (result.data) {
          self.changeRequest = result.data;
        }
      } catch (e) {
        throw e;
      } finally {
        self.changeRequest.loading = false;
      }
    }),
    createOrganization: flow(function* () {
      try {
        self.loading = true;
        self.onValidateForm();
        if (self.orgType.code !== "SEN" && self.orgType.code !=="FIN" && self.orgType.code !=="FUND" && self.orgType.code !=="LIM" && self.orgType.code !=="OTH") {
          // หน่วยงานรัฐวิสาหกิจ
          self.field.resetAll();
          self.subField.resetAll();
          self.shareHolders = [];
        }
        const result = yield orgAPI.create(self);
        return result.data;
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    approveRequest: flow(function* () {
      try {
        self.loading = true;
        const result = yield orgAPI.approveRequest(self.organizeID);
        return result;
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    cancelRequest: flow(function* () {
      try {
        self.loading = true;
        const result = yield orgAPI.cancelRequest(self.organizeID);
        return result;
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    createOrUpdateRequest: flow(function* () {
      try {
        self.loading = true;
        self.onValidateForm();
        if (self.orgType.code !== "SEN" && self.orgType.code !=="FIN" && self.orgType.code !=="FUND" && self.orgType.code !=="LIM" && self.orgType.code !=="OTH") {
          // หน่วยงานรัฐวิสาหกิจ
          self.field.resetAll();
          self.subField.resetAll();
          self.shareHolders = [];
        }
        const result = yield orgAPI.createOrUpdateRequest(
          self,
          self.organizeID
        );
        return result;
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    calculatePdaProportion: flow(function* () {
      try {
        const result = yield orgAPI.calculateORGStatus({
          orgType: self.orgType,
          shareHolders: self.shareHolders,
        });
        self.publicDebtActs = result.data.publicDebtActs;
        self.financeDebtActs = result.data.financeDebtActs;
        self.pdaProportion = result.data.pdaProportion;
        self.fdaProportion = result.data.fdaProportion;
      } catch (e) {
        // ซ่อน Error tigger เพราะ ErrorMessage เมื่อใช้กับ onBlur ที่ stakeholderEdit แล้วจะขึ้นแสดงแค่แปปเดียว
        // self.error.tigger = true;
        // self.error.code = e.code;
        // self.error.title = e.name;
        // self.error.message = e.message;
        // self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        //
      }
    }),
    setAllField: (data: any) => {
      Object.keys(data).forEach((key) => {
        try {
          self[key] = data[key];
        } catch (e) {
          console.log("exception on mapping key:", key);
        }
      });
    },
    setOrgId: (id: number | string) => {
      const _id = typeof id === "string" ? parseInt(id, 10) : id;
      self.organizeID = _id;
    },
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    onAddNewStakeholder: (type: "GOV" | "PRIVATE") => {
      self.shareHolders.push({
        shareHolderID: type === "GOV" ? 0 : null,
      });
    },
    onRemoveStakeholder: (index: number) => {
      self.shareHolders.splice(index, 1);
    },
    onSelectedDebtActs: (
      fieldname: "publicDebtActs" | "financeDebtActs",
      value: ILOVModel,
      checked: boolean
    ) => {
      if (checked === true) {
        self[fieldname].push({
          id: value.lovKey,
          code: value.lovCode,
          description: value.lovValue,
          isSelected: true,
        });
      } else {
        const index = self[fieldname].findIndex(
          (item: ISelectListModel) => item.code === value.lovCode
        );
        if (index >= 0) {
          self[fieldname].splice(index, 1);
        }
      }
    },
    onAddDebtsFile: (fieldname: "lawOfDebts" | "attachFiles", file: File[]) => {
      file.forEach((_file: File) => {
        try {
          const newFileUpload: IFileModel = FileModel.create({});
          newFileUpload.setToBase64Format(_file);
          self.onAddItem(fieldname, newFileUpload);
        } catch (e) {
          console.log("onAddDebtsFile Error: ", e);
        }
      });
    },
    onAddItem: (fieldname: string, value: any) => {
      self[fieldname].push(value);
    },
    onRemoveFile: (
      fieldname: "lawOfDebts" | "attachFiles",
      file: IFileModel
    ) => {
      const index = self[fieldname].findIndex(
        (_file: IFileModel) => _file.fileName === file.fileName
      );
      if (index >= 0) {
        self[fieldname].splice(index, 1);
      }
    },
    setTemplate: (text: string, value: any) => {
      if (self.template === null) {
        self.template = SelectListModel.create({});
      }
      self.template.setField(undefined, value, text);
    },
    onValidateForm: () => {
      if ((self.orgType.code === "SEN" ||self.orgType.code ==="FIN" || self.orgType.code ==="FUND" ||self.orgType.code ==="LIM" || self.orgType.code ==="OTH") && self.shareHoldersPropSummary !== 100) {
        throw {
          name: i18n.t("OrganizeModel.correctlyFill"),
          message: i18n.t("OrganizeModel.validateShareholding"),
        };
      }
    },
    resetAll: () => {
      applySnapshot(self, { changeRequest: {} });
    },
  }));
export type IOrganizeModel = typeof OrganizeModel.Type;
